module.exports = __webpack_public_path__ + "static/media/nintex-header.163859bd.svg";